import { render, staticRenderFns } from "./allocation_window_statuses.vue?vue&type=template&id=e2079eb0&scoped=true&"
import script from "./allocation_window_statuses.vue?vue&type=script&lang=js&"
export * from "./allocation_window_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2079eb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2079eb0')) {
      api.createRecord('e2079eb0', component.options)
    } else {
      api.reload('e2079eb0', component.options)
    }
    module.hot.accept("./allocation_window_statuses.vue?vue&type=template&id=e2079eb0&scoped=true&", function () {
      api.rerender('e2079eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/allocation_window_statuses.vue"
export default component.exports